export const cardDetails = {
    CREDIT: {
        MAIN: {
            fields: [
                ['balance', 'limit', 'outstandingAmount', 'installmentDueDate', 'repaymentRate'],
                ['owner', 'validUntil'],
            ],
        },
    },
};
